import { Alert, Button } from '@mui/material';
import { USER_ROLE_LABELS } from '@atlas/shared';
import { setPreviewRole, usePreviewRole } from '@/lib/previewRole';

/**
 * Persistent reminder that the page is being shown as another role, with the
 * way out. Rendered by `Layout` above the routed content so it survives
 * navigation — the whole point is to browse the site while previewing.
 *
 * Names every previewed role, because two roles together show MORE than either
 * alone and an admin reading one name would draw the wrong conclusion.
 */
export function PreviewRoleBanner() {
  const previewRoles = usePreviewRole();
  if (!previewRoles?.length) return null;
  const label = previewRoles.map((role) => USER_ROLE_LABELS[role]).join(' + ');
  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={() => setPreviewRole(null)}>
          Exit preview
        </Button>
      }
    >
      Viewing as <strong>{label}</strong> — the menu, pages, tabs, home sections and
      spreadsheet columns are as {previewRoles.length > 1 ? 'those roles' : 'that role'} see
      them, Admin included.{' '}
      {previewRoles.length > 1 &&
        'A feature stays visible unless every one of these roles hides it. '}
      Your own permissions are unchanged; this button is the way back.
    </Alert>
  );
}

export default PreviewRoleBanner;
